
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avit",
      function () {
        return require("private-next-pages/avit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avit"])
      });
    }
  